import { IAdServerTargeting } from '../../../typings/IPrebid'
import WebModel from '../../models/WebModel'

// PP helps trick DFP into running Mediavine Direct ads when the
// bid is lower than the MVD campaign price
export function calculatePricePriorityTargeting(
  targeting: IAdServerTargeting | undefined
): Array<string> | undefined {
  if (!targeting) {
    return undefined
  }
  const maxPp: number = Math.floor(parseFloat(targeting.hb_pb as string))
  const pp: Array<string> = []

  if (maxPp > 1) {
    for (let i = 1; i <= maxPp; i++) {
      pp.push(`gt${i}`)
    }
  }

  return pp
}

export const maxFirstLookFloor = 200
export const minFirstLookFloor = 4

/* tslint:disable:no-magic-numbers */
export function calculateFirstLookFloor(
  targeting: IAdServerTargeting | undefined
): string | undefined {
  if (!targeting) {
    return undefined
  }
  const bid: number = parseFloat(targeting.hb_pb as string)
  let flp = minFirstLookFloor

  if (bid > 50.0) {
    // Ridiculous $200 from 100+
    flp = maxFirstLookFloor
  } else if (bid > 2) {
    // Every $1 from 4-100
    flp = Math.ceil(bid * 2)
  }

  return flp.toString()
}
/* tslint:enable:no-magic-numbers */
